var map = {
	"./angle-down/angle-down.svg": "ea5aadd25dd46e3f692a",
	"./angle-up/angle-up.svg": "a5150bc97c16449937df",
	"./archive-filled/archive-filled.colored.svg": "ee2d91aabefb31544fbc",
	"./archive-filled/archive-filled.svg": "dc2246e2bd0139969e08",
	"./archive/archive.colored.svg": "656a9e5522b26e64d9ad",
	"./archive/archive.svg": "e718ccdbee28ae7d5413",
	"./arrow-down/arrow-down.colored.svg": "575bc908d304539e7af1",
	"./arrow-down/arrow-down.svg": "3d2c367c6e87b28d6207",
	"./arrow-stretch/arrow-stretch.colored.svg": "cb093f39c5d9fdb49b21",
	"./arrow-stretch/arrow-stretch.svg": "5fa091bbb8f61e6648cf",
	"./arrow-up/arrow-up.colored.svg": "35d8f8cc659fb15c7394",
	"./arrow-up/arrow-up.svg": "fb350de4e4e27639e276",
	"./cart/cart.colored.svg": "06277e2ade18f30f8de5",
	"./cart/cart.svg": "a4df9b6cc844b9f7e12e",
	"./delete-green/delete-green.sm.colored.svg": "1766c296c2fd2064191a",
	"./delete-green/delete-green.sm.svg": "a960833738d217913006",
	"./delete-interactive/delete-interactive.colored.svg": "de6e07605cab7c7539ee",
	"./delete-interactive/delete-interactive.sm.colored.svg": "371ebbb9241523e593b0",
	"./delete-interactive/delete-interactive.sm.svg": "5542043b2dec13bb36b0",
	"./delete-interactive/delete-interactive.svg": "d44d5c5afaa6d1d8a983",
	"./delete/delete.colored.svg": "ae05cce7e46d29cb7558",
	"./delete/delete.sm.colored.svg": "9b1ae611d904ed5aff32",
	"./delete/delete.sm.svg": "9bcd0d8257fcf166b339",
	"./delete/delete.svg": "6dfff07bde7ec4cf2642",
	"./direction-right/direction-right.colored.svg": "a4260bdc7760e9218b4b",
	"./direction-right/direction-right.svg": "7aa90cb7338cea5855ae",
	"./download/download.colored.svg": "23748584f6747516dc9f",
	"./download/download.svg": "b6706fc4a364d01b5976",
	"./draft/draft.colored.svg": "29c3e1b97db3f28e0c7e",
	"./draft/draft.svg": "155465541f25c8f020f4",
	"./duplicate-interactive/duplicate-interactive.colored.svg": "c2c47cec7e5a077f1cce",
	"./duplicate-interactive/duplicate-interactive.svg": "853e7a97c3a2e715f744",
	"./duplicate/duplicate.colored.svg": "14994ef58af0b7f53d33",
	"./duplicate/duplicate.svg": "887d62f286cf51ccd3bc",
	"./edit-interactive-alt/edit-interactive-alt.colored.svg": "8fc99317719c16215ac9",
	"./edit-interactive-alt/edit-interactive-alt.svg": "f3cfe001f48cf9e8228c",
	"./edit-interactive/edit-interactive.colored.svg": "4af02fb981ac72ac3c94",
	"./edit-interactive/edit-interactive.svg": "74ce3460c04f3755f98b",
	"./edit/edit.colored.svg": "f285ff9bb66e00b74315",
	"./edit/edit.svg": "46f0f914d615b22bf239",
	"./favorite-blue/favorite-blue.colored.svg": "38766af652e51a2f5040",
	"./favorite-blue/favorite-blue.sm.colored.svg": "b5990e0ea293bd915b1b",
	"./favorite-blue/favorite-blue.sm.svg": "69bb4635f81a134b949e",
	"./favorite-blue/favorite-blue.svg": "5ded646f9ec0ed9d821a",
	"./favorite-green/favorite-green.sm.colored.svg": "9784403fd77d1d944fbc",
	"./favorite-green/favorite-green.sm.svg": "f897bcdcbd0747f6f091",
	"./favorite-white/favorite-white.colored.svg": "be33e2323e28f5d6472a",
	"./favorite-white/favorite-white.sm.colored.svg": "a3faff09ef6faf9c5046",
	"./favorite-white/favorite-white.sm.svg": "5bb0bf7886fa2de3e1a3",
	"./favorite-white/favorite-white.svg": "d59d4dc451eb53583ba9",
	"./favorite/favorite.colored.svg": "f74f2a65b5e7535c5a97",
	"./favorite/favorite.sm.colored.svg": "c6cb4c4f679a2e4c22dd",
	"./favorite/favorite.sm.svg": "ec2fe8d1a0f04fb601a2",
	"./favorite/favorite.svg": "4bf561027d715f4e9317",
	"./folder-filled/folder-filled.colored.svg": "b83f83ddd07ad3cf0b29",
	"./folder-filled/folder-filled.svg": "7a268db181409dd6dec6",
	"./folder-with-arrow/folder-with-arrow.colored.svg": "3cd906abf06c620db2f5",
	"./folder-with-arrow/folder-with-arrow.svg": "3366f87adfd28a5e2623",
	"./folder/folder.colored.svg": "2d8290815a78753045ab",
	"./folder/folder.svg": "f6e93a16b323bea190af",
	"./gear/gear.colored.svg": "532d35a1093f0e28a7ac",
	"./gear/gear.svg": "486187231bd4127f17ae",
	"./in-progress/in-progress.svg": "6afd5e9cc9478174b863",
	"./info-message/info-message.svg": "ea43fe42fda69a2cdc7d",
	"./interactive/interactive-finger.svg": "7ca22f950351f9292067",
	"./interactive/interactive-ring.svg": "4104419b93d40534b0f2",
	"./interactive/interactive.colored.svg": "8c41ca58115ec3baf86a",
	"./interactive/interactive.svg": "fb12b53a00637865fc2a",
	"./ios-share-interactive/ios-share-interactive.colored.svg": "34fe11ed61c00aa17b93",
	"./ios-share-interactive/ios-share-interactive.svg": "13cd6d33b0fa399233f0",
	"./like/like.colored.svg": "673836868944d3c94b21",
	"./like/like.svg": "8b8a57801615a6f29ddf",
	"./more-vert-interactive/more-vert-interactive.colored.svg": "f92544c8894f9de604c2",
	"./more-vert-interactive/more-vert-interactive.svg": "77d04bf8a9ef93e37444",
	"./pause/pause.colored.svg": "3bbbdf84ca738abe1e62",
	"./pause/pause.svg": "8905a38ed718516cc3d4",
	"./percent/percent.colored.svg": "a5e6836254b0852c985f",
	"./percent/percent.svg": "b81ba15a9beddf4745ef",
	"./play/play.colored.svg": "69429175da54b3d4ba53",
	"./play/play.svg": "e51be4cc4f9af912de53",
	"./plus/plus.colored.svg": "48989ef0af8693ba0010",
	"./plus/plus.svg": "c0bc755ac4eb85fa85fb",
	"./school-black/school-black.colored.svg": "a47a466d9ee3b4201461",
	"./school-black/school-black.svg": "edc7a77782201756b839",
	"./school-blue/school-blue.colored.svg": "59eead17a2bd27f48300",
	"./school-blue/school-blue.svg": "713320ddcb5194c4cf31",
	"./school-white/school-white.colored.svg": "66f8adde3a92ca1169a8",
	"./school-white/school-white.svg": "4326e97108bea8bce8d4",
	"./school/school.colored.svg": "6b04b8eec943faeb1940",
	"./school/school.svg": "50435fd9436e04170c43",
	"./send-arrow/send-arrow.colored.svg": "97c6b887d37cc003ddc2",
	"./send-arrow/send-arrow.svg": "12b11943ae25e14a7f77",
	"./send-email/send-email.colored.svg": "2f7020d5e7a5d2da4c81",
	"./send-email/send-email.svg": "c62a007e2b825921c928",
	"./share-interactive/share-interactive.colored.svg": "7100256bc27cb5e1c472",
	"./share-interactive/share-interactive.svg": "6be83d49d72061fd819d",
	"./star-rounded/star-rounded.svg": "06877a49ee25da410cd8",
	"./star/star.colored.svg": "8ce0578a15330dd11e6f",
	"./star/star.svg": "703e99af86617180b624",
	"./tune/tune.colored.svg": "f9510538449853a28c84",
	"./tune/tune.svg": "a240866c616b2cfa1cd4",
	"./unarchive/unarchive.colored.svg": "bee5ab324154647558df",
	"./unarchive/unarchive.svg": "52de29198be33d496610",
	"./upload/arrow.svg": "d13acf488c2f89b596f2",
	"./upload/box.svg": "59aa4268cf4650b848c3",
	"./visibility-interactive/visibility-interactive.colored.svg": "7037f001ccf8861fe412",
	"./visibility-interactive/visibility-interactive.svg": "a6443bcaae8b184cb448",
	"./visibility/visibility.colored.svg": "6283ff37b960b1a70548",
	"./visibility/visibility.svg": "5278a39093c9ab9a0fed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "83f99cc5eb56e50da40b";